module.exports = __webpack_public_path__ + "img/hoodie.463d7a47.png";